export var IDENTIFIER_MODAL = 'modal';
export var IDENTIFIER_MODAL_TITLE = 'modal-title';
export var IDENTIFIER_MODAL_SUBTITLE = 'modal-subtitle';
export var IDENTIFIER_MODAL_CONTAINER = 'modal-container';
